import { default as LruCache } from 'lru-cache';

import { Feature, Point, point as createPoint } from '@turf/turf';

import { ILieuucationMapProperties } from '@lieuu/core';

const cache = new LruCache<
  string,
  Feature<Point, { name: string; type: string; id: string }>
>({ max: 5000 });

export const getCentroid = (properties: ILieuucationMapProperties) => {
  const id = `${properties.id}`;

  const cacheValue = cache.get(id);

  if (cacheValue) {
    return cacheValue;
  }

  const centroidPoint = createPoint([properties.centLon, properties.centLat], {
    name: properties.name,
    type: properties.type,
    id: properties.id
  });

  cache.set(id, centroidPoint);

  return centroidPoint;
};
